import SegredoJustica from '@mui/icons-material/Lock';
import { Tooltip } from '@mui/material';
import Box from '@mui/material/Box';
import { red } from '@mui/material/colors';
import Typography from '@mui/material/Typography';
import { action, computed, makeObservable, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import { MdContentCopy } from 'react-icons/md';
import NumeroProcessoUtil from '@/util/NumeroProcessoUtil';
import SystemUtil from '@/util/SystemUtil';
import ReactComponent from './ReactComponent';

class LabelNumeroProcesso extends ReactComponent {
    textoAlternativoTooltip = '';

    constructor(props) {
        super(props);

        makeObservable(this, {
            textoAlternativoTooltip: observable,
            registro: computed,
            segredoJustica: computed,
            numeroProcesso: computed,
            handleCopiarNumeroProcesso: action,
            limparTextoAlternativoTooltip: action,
            textoTooltip: computed,
            processoApregoado: computed,
            isProcessoApregoado: computed
        });
    }

    get registro() {
        return this.observableProps.registro;
    }

    get segredoJustica() {
        return this.registro.segredoJustica;
    }

    get numeroProcesso() {
        return this.registro.processo.numeroCompleto;
    }

    handleCopiarNumeroProcesso = (removerClasseEAdicionarZeros) => {
        if (this.observableProps.habilitarCopiarNumero) {
            const copy = removerClasseEAdicionarZeros
                ? NumeroProcessoUtil.formatarNumeroProcesso(this.numeroProcesso, false, true)
                : this.numeroProcesso;
            SystemUtil.copiarParaAreaDeTransferencia(copy);

            this.textoAlternativoTooltip = removerClasseEAdicionarZeros
                ? 'Número do processo formatado copiado para a área de transferência.'
                : 'Classe e número do processo copiados para a área de transferência.';
        }
    };

    limparTextoAlternativoTooltip = () => {
        this.textoAlternativoTooltip = '';
    };

    get textoTooltip() {
        if (!this.textoAlternativoTooltip && this.observableProps.habilitarCopiarNumero) {
            const textoProcessoApregoado = this.isProcessoApregoado ? `Este processo está apregoado.\n\n` : '';
            return `${textoProcessoApregoado}Copiar classe e número: (Clique simples)\n"${this.numeroProcesso}"\n\nCopiar apenas o número formatado: (Clique duplo)\n"${NumeroProcessoUtil.formatarNumeroProcesso(this.numeroProcesso, false, true)}"`;
        }

        return this.textoAlternativoTooltip;
    }

    get processoApregoado() {
        return this.sessaoStore.processoApregoado;
    }

    get isProcessoApregoado() {
        return (
            this.processoApregoado &&
            this.registro.processo.numeroCompleto === this.processoApregoado.processo.numeroCompleto
        );
    }

    render() {
        return (
            <Typography
                component="span"
                data-expand
                onClick={() => this.handleCopiarNumeroProcesso(false)}
                onDoubleClick={() => this.handleCopiarNumeroProcesso(true)}
                style={{ width: '100%' }}
            >
                {this.observableProps.exibirIcone ? (
                    <Tooltip
                        title={
                            <Typography sx={{ fontSize: '0.9rem', whiteSpace: 'pre-line' }}>
                                {this.textoTooltip}
                            </Typography>
                        }
                        onClose={this.limparTextoAlternativoTooltip}
                    >
                        <span>
                            <MdContentCopy style={{ height: '20px', width: '20px', cursor: 'pointer' }} />
                        </span>
                    </Tooltip>
                ) : (
                    <Box
                        data-expand
                        style={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            color: this.segredoJustica ? red[900] : 'black',
                            fontWeight: this.segredoJustica ? 'bold' : '',
                            width: '100%',
                            display: 'flex',
                            alignItems: 'center'
                        }}
                    >
                        {this.textoTooltip ? (
                            <Tooltip
                                title={
                                    <Typography sx={{ fontSize: '0.9rem', whiteSpace: 'pre-line' }}>
                                        {this.textoTooltip}
                                    </Typography>
                                }
                                onClose={this.limparTextoAlternativoTooltip}
                                placement="top"
                            >
                                <Typography
                                    component="span"
                                    data-expand
                                    sx={this.isProcessoApregoado ? { fontWeight: 'bold' } : {}}
                                >
                                    {this.numeroProcesso}
                                </Typography>
                            </Tooltip>
                        ) : (
                            <Typography
                                component="span"
                                data-expand
                            >
                                {this.numeroProcesso}
                            </Typography>
                        )}
                        {this.registro.segredoJustica && (
                            <Tooltip
                                title={'SEGREDO DE JUSTIÇA'}
                                placement="top"
                            >
                                <SegredoJustica
                                    style={{ height: '18px', width: '18px', marginLeft: '3px', color: red[900] }}
                                />
                            </Tooltip>
                        )}
                    </Box>
                )}
            </Typography>
        );
    }
}

export default inject('stores')(observer(LabelNumeroProcesso));
